export function populateCoverImage(item) {
  if (!item) {
    throw new Error('You must provide a valid item');
  }

  if (!item.coverImage) {
    throw new Error('You must provide a valid coverImage');
  }

  if (!item.coverImage.vertical) {
    throw new Error('You must provide a valid vertical coverImage');
  }

  if (!item.coverImage.horizontal) {
    throw new Error('You must provide a valid horizontal coverImage');
  }

  return {
    vertical: {
      path: item.coverImage.vertical.path,
    },
    horizontal: {
      path: item.coverImage.horizontal.path,
    },
  };
}
